import React from 'react'
import PropTypes from 'prop-types'

import Styles from './styles.scss'


export default function SdkDisclosureRow({ name, use }) {
  return (
    <tr>
      <td className={ Styles.td }>
        { name }
      </td>
      <td className={ Styles.td }>
        { use }
      </td>
    </tr>
  )
}

SdkDisclosureRow.propTypes = {
  name: PropTypes.string.isRequired,

  use: PropTypes.string,
}
